<script>
import { renderNodes } from './renderNode'

// Falha no download do chunk: o bloco some, o resto do documento continua
const failed = { render: () => null }
const lazy = load => () => ({ component: load(), error: failed })

export default {
	name: 'component-tiptap-content',
	// Blocos de mídia: chunk próprio, carregado só quando o documento usa o bloco
	components: {
		TiptapFigure: lazy(() => import(/* webpackChunkName: "TiptapFigure" */ './Figure/Figure.vue')),
		TiptapGallery: lazy(() => import(/* webpackChunkName: "TiptapGallery" */ './Gallery/Gallery.vue')),
		TiptapImageLink: lazy(() => import(/* webpackChunkName: "TiptapImageLink" */ './ImageLink/ImageLink.vue')),
		TiptapVideo: lazy(() => import(/* webpackChunkName: "TiptapVideo" */ './Video/Video.vue')),
		TiptapFileDownload: lazy(() => import(/* webpackChunkName: "TiptapFileDownload" */ './FileDownload/FileDownload.vue')),
	},
	props: {
		doc: {
			type: Object,
			required: true,
		},
	},
	computed: {
		context() {
			return {
				origin: window.location.origin,
				apiRoute: process.env.VUE_APP_API_ROUTE || '',
			}
		},
	},
	render(h) {
		return h('div', { class: 'tiptap-content' }, renderNodes(h, this.doc.content, this.context))
	},
}
</script>

<style lang="stylus" scoped src="./TiptapContent.styl"></style>
